export default __webpack_public_path__ + "static/media/spendCategoryUtilities32.edfd17c2.svg";